import { useNavigate } from 'react-router-dom';
import { Screen } from '../../app/Frame';
import { useMeContext } from '../../app/MeContext';
import { useScreen } from '../../app/shell-context';
import { formatDay } from '../../lib/time';
import { Notice, Opt } from '../../ui/parts';
import { useBooking } from '../BookingContext';

/** Шаг 1 из 5: к кому записываемся. Клиент видит только своих специалистов. */
export function Pick() {
  const me = useMeContext();
  const navigate = useNavigate();
  const { booking, patch } = useBooking();
  const tz = me.center.tz;

  const child = (me.children ?? []).find((c) => c.id === booking.childId) ?? (me.children ?? [])[0];
  const team = child?.team ?? [];

  useScreen('К кому записаться', {
    label: 'Далее',
    disabled: booking.specialistId === null,
    onClick: () => navigate('/service'),
  });

  return (
    <Screen>
      <div>
        <p className="eyebrow">Шаг 1 из 5</p>
        <p className="lead" style={{ marginTop: 6 }}>
          К кому записываемся? У каждой категории своё расписание и свои услуги.
        </p>
      </div>

      <div className="options">
        {team.map((t) => (
          <Opt
            key={t.specialist_id}
            pressed={booking.specialistId === t.specialist_id}
            title={t.specialist_name}
            aside={
              <span style={{ fontWeight: 500, color: 'var(--ink-3)', fontSize: '12.5px' }}>{t.direction_title}</span>
            }
            note={`Ведёт с ${formatDay(t.since, tz)}`}
            onClick={() =>
              patch({
                specialistId: t.specialist_id,
                specialistName: t.specialist_name,
                serviceId: null,
                serviceTitle: '',
                startsAt: null,
              })
            }
          />
        ))}
      </div>

      <Notice kind="calm">
        Нужна другая категория — дефектолог, второй нейропсихолог? Напишите администратору,
        он закрепит специалиста и запись откроется здесь.
      </Notice>
    </Screen>
  );
}
